import { render, staticRenderFns } from "./AllCarts.vue?vue&type=template&id=6133cbba&scoped=true&"
import script from "./AllCarts.vue?vue&type=script&lang=js&"
export * from "./AllCarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133cbba",
  null
  
)

export default component.exports